import { Box } from '@mui/material'
import type { ReactNode } from 'react'

const sharedSx = { display: 'flex', flexDirection: 'column' } as const

// The parent `<Content>` (Router/styles.tsx) applies `theme.spacing(3)` of vertical padding
// (24px top + 24px bottom = 48px). Subtract it so the container fits exactly in the viewport.
const CONTENT_PADDING_Y_PX = 48

interface PageContainerProps {
	children: ReactNode
	py?: number
}

// Top-level wrapper that constrains a page to the viewport so its body never scrolls.
// Children rendered alongside a PageSection stay sticky; the PageSection scrolls.
const PageContainer = ({ children, py = 2 }: PageContainerProps) => (
	<Box
		sx={{
			...sharedSx,
			py,
			height: `calc(100vh - ${CONTENT_PADDING_Y_PX}px)`,
			overflow: 'hidden',
		}}
	>
		{children}
	</Box>
)

// Scrollable area inside a PageContainer. Children render at their natural size;
// if total height exceeds the section, the section itself scrolls.
const PageSection = ({ children }: { children: ReactNode }) => (
	<Box sx={{ ...sharedSx, flex: 1, minHeight: 0, overflow: 'auto' }}>
		{children}
	</Box>
)

export { PageContainer, PageSection }
